/*
 * @Author: zxf
 * @Date: 2022-07-20 14:23:00
 * @LastEditors: cgh
 * @LastEditTime: 2022-09-08 14:52:29
 * @Description: 检测建筑物管理服务
 */
import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;
export const jzwService = {

  // 获取建筑物列表
  queryJzw: (params) => { return axios.get(`${iffApi}/xfjc/jzxx`, { params: params }); },
  // 新增
  saveJzw: (fd) => { return axios.post(`${iffApi}/xfjc/jzxx`, fd); },
  // 更新
  updateJzw: (fd) => { return axios.put(`${iffApi}/xfjc/jzxx`, fd); },
  // 获取建筑物详情
  getJzwInfo: (id) => { return axios.get(`${iffApi}/xfjc/jzxx/${id}`); },
  // 删除建筑物
  deleteJzw: (id) => { return axios.delete(`${iffApi}/xfjc/jzxx/${id}`); }
};
